module.exports = __webpack_public_path__ + "sg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sg.svg
// module id = 798
// module chunks = 0